export const disableExtendPlanSingleButton = ({ target }) => {
    try {
        const modalInstance = window.Extend.modal._instance

        // Check if the inserted Node is the extend modal iframe
        if (target.id === 'extend-offers-modal-iframe' && modalInstance) {
            // Access the modal instance
            const extendPlanButtons = Array.from(modalInstance.component.buttonGroup.el.getElementsByTagName('button') || [])

            // Because there is only one plan, this button cannot be clicked
            if (extendPlanButtons.length === 1) {
                // Disable all button actions
                extendPlanButtons[0].disabled = true
                extendPlanButtons[0].style.pointerEvents = 'none'
            }
        }
    } catch (error) {
        console.error(error)
    }
}
